import Echo from 'laravel-echo'
import SocketIO from 'socket.io-client'
import { authProxyHandler } from './http/request'

export const echoServer = new Echo({
    broadcaster: 'socket.io',
    host: window.location.hostname + ':6001',
    client: SocketIO,
    auth: {
        headers: new Proxy({ Authorization: '' }, authProxyHandler),
    },
})